import React, {Component} from "react";
import {Helmet} from "react-helmet";

function App() {

return (
	<div className='App'>
    <div id="ja-jobs-widget"></div>
	{/* <h1>Geeksforgeeks : How to include an external
	JavaScript library to ReactJS?</h1> */}
	<Helmet>
	<script src=
"http://apps.jobadder.com/widgets/v1/jobs.min.js"
	type="text/javascript" />
	</Helmet>
	</div>
);
}

export default App;
